import {
    config, FirebaseAppOptions,
    firebaseConfigAcceptance,
    firebaseConfigDevelopment,
    firebaseConfigPilot,
    firebaseConfigProd
} from '@/config';

class GabiBackendServiceClientConfig {
    readonly domain: string;
    readonly apiKey: string;

    constructor(domain: string, apiKey: string) {
        this.domain = domain;
        this.apiKey = apiKey;
    }
}

enum GabiEnv {
    not_set = '',
    development = 'development',
    acceptance = 'acceptance',
    production = 'production',
}

class GabiEnvData {
    constructor(
    public readonly name: string,
    public readonly backendConfig: GabiBackendServiceClientConfig,
    public readonly signalingServerUrl: string,
    public readonly firebaseConfig: FirebaseAppOptions,
    ) {
    }
}

const GabiEnvDevelopment = new GabiEnvData(
    GabiEnv.development,
    new GabiBackendServiceClientConfig('dev.api.hinlab.com', config.firebase.apiKey),
    'https://signaling-server-m3ol5225qa-ew.a.run.app',
    firebaseConfigDevelopment,
);

const pilotApiKey = 'AIzaSyDeU1Dkdy8v0h4kkNCMySumQPyd1UJk8Tc';
const GabiEnvPilot = new GabiEnvData(
    GabiEnv.development,
    new GabiBackendServiceClientConfig('pilot.api.hinlab.com', pilotApiKey),
    'https://signaling-server-m3ol5225qa-ew.a.run.app',
    firebaseConfigPilot,
);

const accApiKey = 'AIzaSyCni8AH_fELafkeMxHljFHBCuBOGXlpun0';
const GabiEnvAcceptance = new GabiEnvData(
    GabiEnv.acceptance,
    new GabiBackendServiceClientConfig('acceptance.api.hinlab.com', accApiKey),
    'https://signaling-server-fvmud3qirq-ew.a.run.app',
    firebaseConfigAcceptance,
);

const prodApiKey = 'AIzaSyB2Wab78WrONllG-F69xBQg6NqrnPdAaLE';
const GabiEnvProduction = new GabiEnvData(
    GabiEnv.production,
    new GabiBackendServiceClientConfig('api.hinlab.com', prodApiKey),
    'https://signaling-server-qn7o4bf27a-ew.a.run.app',
    firebaseConfigProd,
);

export {
    GabiEnv, GabiEnvData,
    GabiEnvDevelopment, GabiEnvPilot, GabiEnvAcceptance, GabiEnvProduction,
};
